module.exports = __webpack_public_path__ + "img/tcrb.5dfbbc5d.svg";